// extracted by mini-css-extract-plugin
export var integrations__media = "integrations-module--integrations__media--cvvpa";
export var integrations__gradient = "integrations-module--integrations__gradient--DE7SH";
export var integrations__content = "integrations-module--integrations__content--Iq1ql";
export var integrations__description = "integrations-module--integrations__description--mSYB9";